import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation, Keyboard, Mousewheel, Pagination, Autoplay} from 'swiper/modules';
import {useRef} from 'react';
import useIsMobile from '../../../hook/useIsMobile';
import FadeInUp from '../../../components/FadeInUp';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function PurchasePoint() {

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const isMobile = useIsMobile();

  const data = [
    {
      "index": 1,
      "backgroundColor": "#5100B7",
      "title": "서비스 이용료가 계속 부과되나요?",
      "description": "링콜은 핵심 안전 서비스를 무료로 제공합니다.\n*제품 구매자에 한함"
    },
    {
      "index": 2,
      "backgroundColor": "#0A64B7",
      "title": "사고가 났을 때만 이용 가능한가요?",
      "description": "다양한 생활 서비스를 제공하여\n고객의 편리한 일상을 지원합니다."
    },
    {
      "index": 3,
      "backgroundColor": "#E141A1",
      "title": "서비스 기능 지역에 제한이 있나요?",
      "description": "국내 이동전화 기능 지역 어디든\n서비스 가능합니다."
    },
    {
      "index": 4,
      "backgroundColor": "#018CF1",
      "title": "조달청에 등록된 상품인가요?",
      "description": "링콜은 조달청 벤처나라에 등록된 100% 국산\n벤처기업 상품입니다."
    }
  ];

  return (
    <section className='wrapper top-space'>
      <FadeInUp>
        <h2 className='font-bold text-title2 lg:text-display2 text-center'>
          왜 링콜인가요?<br/>
          기능부터 신뢰까지, 선택의 모든 이유
        </h2>
      </FadeInUp>

      <FadeInUp className='relative'>
        <Swiper
        loop={true}
        autoplay={{
          delay: 3000,
          pauseOnMouseEnter: false,
          disableOnInteraction: false
        }}
        pagination={isMobile}
        spaceBetween={0}
        speed={800}
        navigation={{
          nextEl: nextRef.current,
          prevEl: prevRef.current, 
        }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        mousewheel={true}
        keyboard={true}
        modules={[isMobile ? Pagination : Navigation, Mousewheel, Keyboard, Autoplay]}
        className='mt-[40px] lg:mt-[60px] aspect-[335/446] lg:aspect-[880/500] rounded-[16px] lg:rounded-[28px]'
        style={{
          "--swiper-pagination-color": "#FFF",
        }}
      >
        {
          data.map(item => (
            <SwiperSlide 
              className='flex flex-col justify-between items-center pt-[46px] px-[5%] lg:pt-[56px] pb-[60px] lg:pb-[44px] [&>*]:text-[#FAFAFA]' 
              style={{ backgroundColor: item.backgroundColor }}
            >
              <div className='text-heading1 lg:text-title1 font-bold text-center'>
                {item.title}
              </div> 
            
              <img
                className='w-[50%] lg:w-[30%]'
                src={`${process.env.REACT_APP_STATIC_URL}/images/main/purchase_point_icon${item.index}.png`}
              />

              <div className='font-medium text-body1 lg:text-heading1 text-center whitespace-pre-line'>
                {item.description} 
              </div>
            </SwiperSlide>
          ))
        }
      </Swiper>
      <div className={isMobile ? 'hidden' : ''}>
        <button className='absolute top-1/2 left-[20px] w-[52px] h-[52px] -translate-y-1/2 bg-black bg-opacity-35 rounded-[50%] z-[2]' ref={prevRef}>
          <svg className='m-auto' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <button className='absolute top-1/2 right-[20px] w-[52px] h-[52px] -translate-y-1/2 bg-black bg-opacity-35 rounded-[50%] z-[2]' ref={nextRef}>
          <svg className='m-auto rotate-180' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
      </FadeInUp>
    </section>
  )
}